import styled from "styled-components"
import media from "@irati/ui/src/global/media"
import {Row} from "react-bootstrap"
import Hr from "@irati/ui/src/Layout/Hr"
import Button from "@irati/ui/src/Button"
import {H4, H5} from "@irati/ui/src//Typography/Heading"
import BrandAvatar from "@irati/ui/src/BrandAvatar"

export const RewardAvatar = styled(BrandAvatar)`
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 60px;
    height: 60px;
  `}

  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    width: 80px;
    height: 80px;
  `}
`

export const StyledRow = styled(Row)`
  padding: 0 0px 30px;
`

export const StyledHr = styled(Hr)`
  margin: 0 15px 20px 15px;
  width: calc(100% - 30px);
`

export const StyledButton = styled(Button)`
  margin-bottom: 10px;
  width: 100%;
`

export const Title = styled(H4)`
  word-wrap: break-word;
  margin-bottom: 10px;
`

export const SubTitle = styled(H5)`
  word-wrap: break-word;
  ${media.tablet`
    font-size: 14px;
  `}
`
